import apiClient from './client';

export const listEmployees = (params) => apiClient.get('/users', { params }).then((r) => r.data);
export const getEmployee = (id) => apiClient.get(`/users/${id}`).then((r) => r.data);
export const createEmployee = (payload) => apiClient.post('/users', payload).then((r) => r.data);
export const updateEmployee = (id, payload) => apiClient.put(`/users/${id}`, payload).then((r) => r.data);
export const setEmployeePassword = (id, newPassword) => apiClient.patch(`/users/${id}/password`, { newPassword }).then((r) => r.data);
export const setEmployeeStatus = (id, status) => apiClient.patch(`/users/${id}/status`, { status }).then((r) => r.data);
export const setEmployeeAssignedClients = (id, clientIds) => apiClient.patch(`/users/${id}/assigned-clients`, { clientIds }).then((r) => r.data);
export const getEmployeePerformance = (id) => apiClient.get(`/users/${id}/performance`).then((r) => r.data);
export const deleteEmployee = (id) => apiClient.delete(`/users/${id}`).then((r) => r.data);
